module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-contact-bd1c152a16c884e87395668bbcf323e5.png";